import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Observable, of, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {AppConfigService} from '../app-config.service';

export class OrderDTO {
  constructor(
      public orders: OrdersDTO[] = []
  ) {
  }
}

export class OrdersDTO {
  constructor(
      public cancelOrder: false,
      public code: string,
      public officeDepotOrderId: string,
      public status: string,
      public statusDisplay: string,
      public total: TotalDTO,
      public placed: string
  ) {
  }
}

export class TotalDTO {
  public value: number;
}

@Injectable({
  providedIn: 'root'
})
export class ListOrdersService {

  private URL = '';
  private token = localStorage.getItem('token');

  constructor(
      private http: HttpClient,
      private formBuilder: FormBuilder,
      private configService: AppConfigService
  ) {
   this.URL = this.configService.getConfig().urlOrdersList;
  }

  getListOrders(): Observable<OrderDTO> {

    const params = new HttpParams()
        .set('email', localStorage.getItem('userEmail'))
        .set('company', this.configService.getConfig().companyName)
        .set('token', localStorage.getItem('token'));

    console.log('listOrders', params); // Debug: Verificar los datos enviados
    console.log('Url ListOrders', this.URL);
    return this.http.get<OrderDTO>(`${this.URL}/listOrders`, { params }).pipe(
        tap(response => {
          console.log('Response:', response);
        }),
        catchError(error => {
          console.error('Error en listOrders:', error);
          return throwError(() => error);
        })
    );
  }

  validateOrder(code: string): Observable<boolean> {
    console.log('validateOrder', code);

    const params = new HttpParams()
        .set('email', localStorage.getItem('userEmail') || '')
        .set('code', code)
        .set('company', this.configService.getConfig().companyName);

    console.log('validateOrder- Params', params);
    const headers = new HttpHeaders()
        .set('Authorization', `${this.token}`);

    console.log('validateOrder- Headers', this.token);

    return this.http.get<boolean>(`${this.URL}/validateOrder`, { params, headers }).pipe(
        tap(response => {
          console.log('validateOrder: true', response);
          return false;
        }),
        catchError(error => {
          console.error('Error al validar la orden', error);
          return of(false); // 👈 importante: devolvemos un Observable<boolean>
        })
    );
  }
}
